export default ({ store, env }) => {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.attributes.defer = true;
        script.src = `${window.location.protocol}//${window.location.hostname}/build/marketing/index.js?${env.buildNr}`;
        document.body.appendChild(script);

        script.onload = () => {
            const marketing = window.marketing || {};
            store.$marketing = marketing;

            resolve(marketing);
        };

        script.onerror = (error) => {
            reject(error);
        };
    });
};
